import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        areas: false
      },
      options: {
        areas: []
      },
      selected: {
        area: ''
      },
      editable: {
        area: ''
      }
    }
  },

  watch: {
    'selected.team' (team) {
      if (team?.id) {
        this.getAreas(this, '', team.id).finally(() => {
          if (this.editable.area) {
            this.selected.area = QUERY.find(this.options.areas, {
              id: this.editable.area
            }) || ''

            this.editable.area = ''
          }
        })
      } else {
        this.selected.area = ''
        this.options.areas = []
      }
    }
  },

  methods: {

    async getAreas (context, search = '', team = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.area
      const fetching = context.fetching?.areas
      const options = context.options?.areas

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.areas = true
      context.selected.area = ''

      const filters = {
        filter_text: search,
        team_id: team
      }

      return await SSharedList.getAreas(filters).then(
        ({ data }) => {
          context.options.areas = data
        }
      ).catch(() => {
        context.options.areas = []
      }).finally(() => {
        context.fetching.areas = false
      })
    },

    async searchAreas (search, loading) {
      this.searchAreasProvider(this, search, loading)
    },

    searchAreasProvider: QUERY.debounce(
      ({ options, selected }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.areas, {
          keys: ['area_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search,
            team_id: selected.team?.id || ''
          }

          SSharedList.getAreas(filters).then(
            ({ data }) => {
              options.areas = data
            }
          ).catch(() => {
            options.areas = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
